<template>
	<template v-if="hasAny">
		<anchor-element tag="span" :chain="chain" class="bottomBadge bell-menu" @click="toggleOpen"><span><sym-icon :name="ringing ? 'bell-ring' : 'bell'"></sym-icon></span></anchor-element>
		<boat-element :tag="BellMenuBoat" :chain="chain" :notifications="notifications"></boat-element>
	</template>
</template>

<script setup lang="ts">
import SymIcon from "@fd/helpers/SymIcon.vue";
import {computed, watch} from "vue";
import {createChain} from "@/ui/paneltree/PanelTree.ts";
import AnchorElement from "@/ui/paneltree/AnchorElement.vue";
import BoatElement from "@/ui/paneltree/BoatElement.vue";
import BellMenuBoat from "@/ui/mouse/BellMenuBoat.vue";
import type {Notification} from "@t/meta/Notification.ts";

const props = defineProps<{
	notifications: Notification[]
}>();

const emit = defineEmits(['visibility']);	// inform parent about visibility changes

const hasAny = computed<boolean>(() => Array.isArray(props.notifications) && props.notifications.length > 0);
const ringing = computed<boolean>(() => false);

const chain = createChain({
	rule: {
		ah: 100, av: 100,
		bh: 100, bv: 0,
		x: 0, y: 0
	}
}, "bell-menu");


function toggleOpen() {
	chain.toggle();
}

watch(() => chain.visible.value, (state) =>  emit("visibility", state));
</script>

<style>
.bell-menu {
	cursor: pointer;
}
</style>